import {Action} from '@ngrx/store';
import {Funktionsbereich, Kontakt, KontaktDetail, KontaktTelefon} from '../../../clients/kontaktverwaltung';

export const PAGE_STATE_RESET = '[KontaktePage] Page State reset';

export const FUNKTIONSBEREICH_KONTAKTE_LADEN = '[KontaktePage] Funktionsbereich Kontakte laden';

export const AKTUELLEN_FUNKTIONSBEREICH_GESETZT = '[KontaktePage] Aktuellen Funktionsbereich gesetzt';
export const AKTUELLEN_KONTAKT_SETZEN = '[KontaktePage] Aktuellen Kontakt setzen';
export const KONTAKT_DETAILS_LADEN = '[KontaktePage] Kontakt Details laden';
export const AKTUELLEN_KONTAKT_AENDERN = '[KontaktePage] Aktuellen Kontakt ändern';
export const NEUER_KONTAKT = '[KontaktePage] Neuen Kontakt anlegen';
export const KONTAKT_SPEICHERN = '[KontaktePage] Kontakt speichern';
export const KONTAKT_LOESCHEN = '[KontaktePage] Kontakt loeschen';
export const KONTAKT_BEARBEITUNG_ABBRECHEN = '[KontaktePage] Kontakt Bearbeitung abbrechen';


export const EXTERNER_KONTAKT_TOGGLE = '[KontaktePage] Externer Kontakt toggle';
export const KONTAKT_AKTIV_TOGGLE = '[KontaktePage] Kontakt Aktiv Toggle';

export const AKTUELLE_TELEFONNUMMER_SETZEN = '[KontaktePage] Aktuelle Telefonnummer setzen';
export const AKTUELLE_TELEFONNUMMER_AENDERN = '[KontaktePage] Aktuelle Telefonnummer ändern';
export const NEUE_TELEFONNUMMER = '[KontaktePage] Neue Telefonnummer';
export const TELEFONNUMMER_SPEICHERN = '[KontaktePage] Telefonnummer speichern';
export const TELEFONNUMMER_LOESCHEN = '[KontaktePage] Telefonnummer löschen';
export const TELEFONNUMMER_BEARBEITUNG_ABBRECHEN = '[KontaktePage] Telefonnummer Bearbeitung abbrechen';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// FUNKTIONSBEREICHE-KONTAKTE
export class FunktionsbereichKontakteLadenAction implements Action {
    readonly type = FUNKTIONSBEREICH_KONTAKTE_LADEN;

    constructor() {
    }
}

export class AktuellenFunktionsbereichSetzenAction implements Action {
    readonly type = AKTUELLEN_FUNKTIONSBEREICH_GESETZT;

    constructor(public payload: Funktionsbereich) {
    }
}

export class AktuellenKontaktSetzenAction implements Action {
    readonly type = AKTUELLEN_KONTAKT_SETZEN;

    constructor(public payload: Kontakt) {
    }
}

export class KontaktDetailsLadenAction implements Action {
    readonly type = KONTAKT_DETAILS_LADEN;

    constructor() {
    }
}

export class AktuellenKontaktAendernAction implements Action {
    readonly type = AKTUELLEN_KONTAKT_AENDERN;

    constructor(public payload: KontaktDetail) {
    }
}

export class NeuerKontaktAction implements Action {
    readonly type = NEUER_KONTAKT;

    constructor(public payload: string) {
    }
}

export class KontaktSpeichernAction implements Action {
    readonly type = KONTAKT_SPEICHERN;

    constructor() {
    }
}

export class KontaktLoeschenAction implements Action {
    readonly type = KONTAKT_LOESCHEN;

    constructor() {
    }
}

export class KontaktBearbeitungAbbrechenAction implements Action {
    readonly type = KONTAKT_BEARBEITUNG_ABBRECHEN;

    constructor() {
    }
}

export class ExternerKontaktToggleAction implements Action {
    readonly type = EXTERNER_KONTAKT_TOGGLE;

    constructor(public payload: boolean) {
    }
}

export class KontaktAktivToggleAction implements Action {
    readonly type = KONTAKT_AKTIV_TOGGLE;

    constructor(public payload: boolean) {
    }
}

export class AktuelleTelefonnummerSetzenAction implements Action {
    readonly type = AKTUELLE_TELEFONNUMMER_SETZEN;

    constructor(public payload: KontaktTelefon) {
    }
}

export class AktuelleTelefonnummerAendernAction implements Action {
    readonly type = AKTUELLE_TELEFONNUMMER_AENDERN;

    constructor(public payload: KontaktTelefon) {
    }
}

export class NeueTelefonnummerAction implements Action {
    readonly type = NEUE_TELEFONNUMMER;

    constructor() {
    }
}

export class TelefonnummerSpeichernAction implements Action {
    readonly type = TELEFONNUMMER_SPEICHERN;

    constructor() {
    }
}

export class TelefonnummerLoeschenAction implements Action {
    readonly type = TELEFONNUMMER_LOESCHEN;
    constructor() {
    }
}

export class TelefonnummerBearbeitungAbbrechenAction implements Action {
    readonly type = TELEFONNUMMER_BEARBEITUNG_ABBRECHEN;

    constructor() {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    AktuellenFunktionsbereichSetzenAction
    | FunktionsbereichKontakteLadenAction
    | AktuellenKontaktSetzenAction
    | KontaktDetailsLadenAction
    | AktuellenKontaktAendernAction
    | NeuerKontaktAction
    | KontaktSpeichernAction
    | KontaktLoeschenAction
    | KontaktBearbeitungAbbrechenAction
    | ExternerKontaktToggleAction
    | KontaktAktivToggleAction
    | AktuelleTelefonnummerSetzenAction
    | AktuelleTelefonnummerAendernAction
    | NeueTelefonnummerAction
    | TelefonnummerSpeichernAction
    | TelefonnummerLoeschenAction
    | TelefonnummerBearbeitungAbbrechenAction
    | PageStateResetAction
    ;
